<template>
  <div class="recharge_left capital_first" v-if="central_ucenter_transfer_status == 1">
    <el-card class="box-card common-bg" shadow="never">
      <div slot="header" class="clearfix">
        <el-col :span="12">
          <h3>{{$t('pc.myaccount.platform_transfer')}} </h3>
        </el-col>
      </div>
      <el-tabs>
        <el-tab-pane id="isFromCoupon1">
          <h4 slot="label"> {{$t('pc.myaccount.platform_transfer')}}</h4>
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <el-row>
                <!-- Current Asset -->
                <el-col :span="5" style="text-align: center;line-height: 36px" class="common_border">
                  <h3>{{ $t('pc.myaccount.current_assets') }} </h3>
                  <p class="text_red_color" style="font-size: 16px;">{{ cash }}</p>
                </el-col>

                <!-- DNHK -->
                <el-col :span="5" style="text-align: center;line-height: 30px;margin-left:20px;" class="common_border">
                  <h5 style="font-weight: 200;margin-bottom: 3px;">{{ $t('pc.platformtransfer.dnzq') }}</h5>
                  <el-button
                    type="primary"
                    class="button_blue_color"
                    @click="openMoveOut('JNZQ')"
                  >
                    {{ $t('pc.agency.transfer') }}
                  </el-button>
                </el-col>

                <!-- DNUS -->
                <el-col :span="5" style="text-align: center;line-height: 30px;margin-left:20px;" class="common_border">
                  <h5 style="font-weight: 200;margin-bottom: 3px;">{{ $t('pc.platformtransfer.dnhk') }}</h5>
                  <el-button
                    type="primary"
                    class="button_blue_color"
                    @click="openMoveOut('JNHK')"
                  >
                    {{ $t('pc.agency.transfer') }}
                  </el-button>
                </el-col>
              </el-row>
            </div>
          </el-card>
        </el-tab-pane>
        <el-tab-pane id="isFromCoupon2">
          <h4 slot="label">{{ $t('pc.myaccount.bill') }}</h4>
          <el-card>
            <el-form :inline="true" size="mini">
              <el-form-item :label=" $t('pc.trading.date') ">
                <el-date-picker
                  v-model="platformTransferDetails.date"
                  type="daterange"
                  value-format="yyyy-MM-dd"
                  :range-separator="$t('pc.myaccount.to')"
                  :start-placeholder="$t('pc.myaccount.start_date')"
                  :end-placeholder="$t('pc.myaccount.end_date')"
                >
                </el-date-picker>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" class="button_blue_color" @click="getPlatformTransferDetails">{{ $t('pc.myaccount.search') }}</el-button>
              </el-form-item>
            </el-form>

   
            <el-table :data="platformTransferDetails.data" size="mini" stripe style="width: 100%">
            <el-table-column width="140" prop="order" align="center" :label=" $t('pc.platformtransfer.order_number') "></el-table-column>
            <el-table-column width="160" prop="reference_number" align="center" :label="$t('pc.platformtransfer.central_system_number')"></el-table-column>
            <el-table-column width="120" prop="number" align="center" :label="$t('pc.platformtransfer.transfer_amount')"></el-table-column>
            <el-table-column width="120" prop="balance" align="center" :label="$t('pc.platformtransfer.account_balance')"></el-table-column>
            <el-table-column width="130" prop="type" align="center" :label="$t('pc.platformtransfer.transfer_operation_type')">
              <template slot-scope="scope">
                <span
                 :style="{
  color:
    (scope.row.type === '转入' || scope.row.type === 'Transfer In')
      ? '#3f7a21'
      : (scope.row.type === '转出' || scope.row.type === 'Transfer Out')
      ? '#D02E27'
      : '#0D268D'
}"
                >
                  {{ scope.row.type }}
                </span>
              </template>
            </el-table-column>
            <el-table-column width="100" prop="status" align="center" :label="$t('pc.trading.status')">
              <template slot-scope="scope">
                <span
                  :style="{
                    color:
                      scope.row.status === '成功'|| scope.row.status === 'Success'
                        ? '#3f7a21'   
                        : scope.row.status === '失败' || scope.row.status === 'Fail'
                        ? '#D02E27'  
                        : '#0D268D'   
                  }"
                >
                  {{ scope.row.status }}
                </span>
              </template>
            </el-table-column>
            <el-table-column width="130" prop="request_platform" align="center" :label="$t('pc.platformtransfer.accessed_platform')"></el-table-column>
            <el-table-column width="180" prop="time" align="center" :label="$t('pc.platformtransfer.create_time')"></el-table-column>
          </el-table>

            <div class="changePage" style="padding-top: 15px;">
              <el-button
                type="primary"
                class="button_blue_color"
                icon="el-icon-arrow-left"
                @click="prevPlatformTransferDetails"
                size="mini"
              >
                {{ $t('pc.myaccount.previous_page') }}
              </el-button>
              <el-button
                type="primary"
                class="button_blue_color"
                icon="el-icon-arrow-right"
                @click="nextPlatformTransferDetails"
                size="mini"
                style="float: right"
              >
                {{ $t('pc.myaccount.next_page') }}
              </el-button>
            </div>
          </el-card>
        </el-tab-pane>
      </el-tabs>
    </el-card>

    <!-- DIALOG: TRANSFER OUT -->
    <el-dialog
      class="platform_transfer_popup"
      :title="$t('pc.platformtransfer.transfer_to') + ' ' + (selectedPlatformText || 'Other Platform')"
      :visible.sync="moveOutState"
    >
      <el-form ref="form" size="small" label-position="left" class="custom-transfer-form" label-width="120px">
        <el-form-item :label="$t('pc.myaccount.account_balance')">
          <!-- <h4 slot="label">{{ $t('pc.myaccount.account_balance') }}:</h4> -->
          <p>{{ cash }} {{ $t('pc.platformtransfer.currency') }}</p>
        </el-form-item>

        <el-form-item :label="$t('pc.agency.transfer')">
          <!-- <h4 slot="label">{{ $t('pc.agency.transfer') }}:</h4> -->
          <el-input
            oninput="value=value.replace(/[^\d.]/g,'')"
            v-model="moveOutAmount"
            placeholder=""
             @input="calculateExchangeRate"
          ></el-input>
        </el-form-item>
          <div class="row" style="display: flex;" v-if="dn_exchange_ratio>0 && selectedPlatform=='JNZQ'">
          <div class="col-md-8" style="display: flex;">
               </div>
             <div class="col-md-8" style="display: flex;" >
               <h5 slot="label">USD : RMB = 1:<span>{{ dn_exchange_ratio }}</span> </h5>
             </div>
              <div class="col-md-8" style="display: flex;">
               &nbsp;&nbsp;&nbsp;&nbsp;
               </div>
              <div class="col-md-8" style="display: flex;" >
               <h5 slot="label" >{{ $t('pc.cuc.amount_received') }} = <span>{{ dn_exchange_amount }}</span>{{$t('pc.cuc.dn_currency')}} </h5>
             </div>
           </div>
             <div class="row" style="display: flex;" v-if="hk_exchange_ratio>0 && selectedPlatform=='JNHK'">
          <div class="col-md-8" style="display: flex;">
               </div>
             <div class="col-md-8" style="display: flex;" >
               <h5 slot="label">USD : HKD = 1:<span>{{ hk_exchange_ratio }}</span> </h5>
             </div>
              <div class="col-md-8" style="display: flex;">
               &nbsp;&nbsp;&nbsp;&nbsp;
               </div>
              <div class="col-md-8" style="display: flex;" >
               <h5 slot="label">{{ $t('pc.cuc.amount_received') }} = <span>{{ hk_exchange_amount }}</span>{{$t('pc.cuc.hk_currency')}}</h5>
             </div>
           </div>
      </el-form>
      <div slot="footer" class="dialog-footer half-buttons">
        <el-button @click="moveOutState = false">{{ $t('pc.capital.withdraw.bankcard_popup_cancel_button') }}</el-button>
        <el-button type="primary" class="button_blue_color" @click="moveout">{{ $t('pc.capital.withdraw.bankcard_popup_confirm_button') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "platformTransfer",
  data() {
    return {
      amount: 0,
      cash: 0,
      moveInAmount: 0,
      annual_interest_rate: 0,
      moveOutAmount: 0,
      moveInState: false,
      moveOutState: false,
      central_ucenter_transfer_status: 0,
      platformTransferDetails: {
        date: [],
        data: [],
        page: 1,
        num: 20
      },
      platform: "",
      selectedPlatform: "", 
      selectedPlatformText : "",
      selectedPlatformBalance: 0,
      dn_exchange_ratio:0,
       hk_exchange_ratio:0,
       hk_exchange_amount:0,
       dn_exchange_amount:0
    };
  },
  methods: {
    calculateExchangeRate(value){
       if(this.selectedPlatform=='JNZQ'){
            this.dn_exchange_amount=(value*this.dn_exchange_ratio).toFixed(2);
       }
       else if(this.selectedPlatform=='JNHK'){
            this.hk_exchange_amount=(value*this.hk_exchange_ratio).toFixed(2);
       }
     },
     getExchangeRatio(selectdPlt){
       let that=this;
       var transfer_plt=selectdPlt=='JNZQ'?'RMB':'HKD';
        that
         .$http({
           url: "/",
           method: "post",
           data: {
             nozzle: "platform_transfer",
             token: sessionStorage.getItem("token"),
             action: "transaction_ratio",
             from: "USD",
             to: transfer_plt
           }
         })
         .then(function(res) {
           if (res.data.code == 1) {
             if(transfer_plt=='RMB'){
               that.dn_exchange_ratio=res.data.data;
             }else{
               that.hk_exchange_ratio=res.data.data;
             }
           } else if (res.data.code == 0 || res.data.code == -1) {
             that.$message.error(res.data.msg);
           }
         });
 
     },
    openMoveOut(platform) {
      this.selectedPlatform = platform;
      if (platform === "JNZQ") {
        this.selectedPlatformText = this.$t('pc.platformtransfer.dnzq');   
      } else if (platform === "JNHK") {
        this.selectedPlatformText = this.$t('pc.platformtransfer.dnhk');
      } else {
        this.selectedPlatformText = "Other Platform";
      }
      this.getExchangeRatio(platform);
       this.dn_exchange_amount=0;
       this.hk_exchange_amount=0;
      this.moveOutAmount = 0;
      this.moveOutState = true;
    },

    getPlatformTransferDetails() {
      let that = this;

      const requestData = {
        nozzle: "platform_transfer",
        token: sessionStorage.getItem("token"),
        action: "transaction_log",
        page: that.platformTransferDetails.page,
        num: that.platformTransferDetails.num
      };

      if (that.platformTransferDetails.date && that.platformTransferDetails.date.length === 2) {
        requestData.start = that.platformTransferDetails.date[0];
        requestData.end = that.platformTransferDetails.date[1];
      }

      that
        .$http({
          url: "/",
          method: "post",
          data: requestData
        })
        .then(function (res) {
          if (res.data.code == 1) {
            let resData = res.data;
            that.platformTransferDetails.data = resData.data;
          } else if (res.data.code == 0 || res.data.code == -1) {
            that.$message.error(that.$t(res.data.msg));
          }
        });
    },
    //获取用户信息
    getUserinfo() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "user",
            token: sessionStorage.getItem("token")
          }
        })
        .then(function(res) {
          if (res.data.code == 1) {
            that.cash = res.data.data.cash;
            that.moveInAmount = that.cash;
            that.moveOutAmount = 0;
          } else if (res.data.code == 0 || res.data.code == -1) {
            that.$message.error(that.$t(res.data.msg));
          }
        });
    },
    getCentralTransferStatus() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "sysconfig",
            token: sessionStorage.getItem("token"),
            name: "central_ucenter_transfer_status"
          }
        })
        .then(function(res) {
          let resData = res.data;
          if (res.data.code === 1) {
            let resData = res.data;
            that.central_ucenter_transfer_status = resData.data;
          } else if (res.data.code === 0 || res.data.code === -1) {
            that.$toast.fail(resData.msg);
          }
        });
    },
    prevPlatformTransferDetails() {
      let page = this.platformTransferDetails.page;
      if (page == 1) {
        this.$message({
          message: this.$t('pc.timebao.first_page'),
          type: 'warning'
        });
      } else {
        this.platformTransferDetails.page = page - 1;
        this.getPlatformTransferDetails();
      }
    },
    nextPlatformTransferDetails() {
      let page = this.platformTransferDetails.page;
      if (this.platformTransferDetails.length < 20) {
        this.$message({
          message: this.$t('pc.timebao.last_page'),
          type: 'warning'
        });
      } else {
        this.platformTransferDetails.page = page + 1;
        this.getPlatformTransferDetails();
      }
    },

    moveout() {
      let that = this;
      let money = that.moveOutAmount;
      let request_platform = that.selectedPlatform;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "platform_transfer",
            token: sessionStorage.getItem("token"),
            action: "transferout",
            amount: money,
            request_platform: request_platform
          }
        })
        .then(function(res) {
          if (res.data.code == 1) {
            that.moveOutState = false;
            that.$message({
              message: that.$t(res.data.msg),
              type: "success",
              onClose: function() {
                // reload data
                that.mainMethod();
              }
            });
          } else if (res.data.code == 0 || res.data.code == -1) {
          that.$message.error(that.$t(res.data.msg));
          }
        });
    },

    mainMethod() {
      this.getPlatformTransferDetails();
      this.getUserinfo();
    }
  },
  mounted() {
    this.getCentralTransferStatus();
    this.getPlatformTransferDetails();
    this.getUserinfo();
  }
};
</script>

<style scoped>
.half-buttons {
  display: flex;
}

.half-buttons .el-button {
  width: 50%;
}
/deep/ .el-tabs__item.is-active {
  color: #0D268D !important;
}

/deep/ .el-tabs__item:hover {
  color: #0D268D !important;
}

/deep/ .el-tabs__active-bar {
  background-color: #0D268D !important;
}

/deep/ .common_border1 {
  padding: 15px !important;
}
</style>

<style>
.platform_transfer_popup .el-dialog {
  width: 30% !important;
}
</style>



// WEBPACK FOOTER //
// src/components/platformTransfer.vue